import { SidePanelProvider } from "components/SidePanel/SidePanelContext";
import SidePanelRoot from "components/SidePanel/SidePanelRoot";
import SidebarNavigation from "components/SidebarNavigation/SidebarNavigation";
import { loadTheme } from "components/theme/theme";
import TopBar from "components/TopNavigation/TopBar";
import TopNavigation from "components/TopNavigation/TopNavigation";
import moment from "moment";
import { signalRStart } from "notifications";
import React, { useMemo } from "react";
import { getNewButton, renderBreadcrumbsIfDefined } from "./bootstrapNavigation";
import DefaultProviders from "./DefaultProviders";
import { Outlet } from "react-router";
import TopBarAnonymous from "components/TopNavigation/TopBarAnonymous";
import { PlanningProvider } from "PlanningContext/PlanningContext";

export const init = () => {
  loadTheme();

  moment.locale(site.culture.uiLocale);

  if (site.currentUser) {
    signalRStart();
  }
}

const SystemOneApp = (props: React.PropsWithChildren<any>) => {
  useMemo(() => {
    init();
  }, []);

  if (site.currentEnvironment === null) {
    return <DefaultProviders>
      <div id="pagecontainer">
        <div className="flex">
          <div style={{
            width: "100%",
            overflowX: "hidden",
          }}>
            <TopBarAnonymous />
            <div id="contentholder">
              <Outlet />
              {props.children}
            </div>
          </div>
          <SidePanelRoot />
        </div>
      </div>
    </DefaultProviders>;
  }

  return <DefaultProviders>
    <SidePanelProvider>
      <PlanningProvider>
        <div id="pagecontainer">
          <SidebarNavigation
            navigation={site.navigation}
            currentPage={site.currentPage}
          />
          <div className="flex">
            <div style={{
              width: "100%",
              overflowX: "hidden",
            }}>
              <TopBar
                currentUser={site.currentUser}
                environmentType={site.currentEnvironment.type}
                notificationCount={site.notificationCount}
                onMenuOpen={() => { window.onSideNavOpen(); }}
              />
              {renderBreadcrumbsIfDefined()}
              <TopNavigation
                currentPage={site.currentPage}
                navigation={site.navigation}
                newButton={getNewButton()}
              />
              <div id="contentholder">
                <Outlet />
                {props.children}
              </div>
            </div>
            <SidePanelRoot />
          </div>
        </div>
      </PlanningProvider>
    </SidePanelProvider>
  </DefaultProviders>;
};

export default SystemOneApp;